module.exports = (serviceId) => serviceId.split(':service:')[0]
